import React, { useState } from 'react';
import { 
  Navbar, Nav, NavDropdown, Button, Modal, Alert 
} from 'react-bootstrap';
import { 
  FaBars, FaSignOutAlt, FaUserCircle, FaHome
} from 'react-icons/fa';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';

const Header = ({ toggleSidebar }) => {
  const navigate = useNavigate();
  const { user, userProfile, logout } = useAuth();
  
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [loggingOut, setLoggingOut] = useState(false);
  const [error, setError] = useState(null);

  const handleLogout = async () => {
    try {
      setLoggingOut(true);
      setError(null);
      
      await logout();
      navigate('/login');
    } catch (error) {
      console.error('Erro ao fazer logout:', error);
      setError('Erro ao fazer logout. Tente novamente.');
    } finally {
      setLoggingOut(false);
      setShowLogoutModal(false);
    }
  };

  const formatUserName = () => {
    if (userProfile?.full_name) {
      const names = userProfile.full_name.split(' ');
      if (names.length >= 2) {
        return `${names[0]} ${names[names.length - 1]}`;
      }
      return names[0];
    }
    return user?.email?.split('@')[0] || 'Usuário';
  };

  return (
    <>
      <Navbar bg="white" className="border-bottom px-3" expand="lg">
        <div className="d-flex align-items-center">
          <Button
            variant="outline-secondary"
            size="sm"
            onClick={toggleSidebar}
            className="me-3"
          >
            <FaBars />
          </Button>
          
          <Navbar.Brand className="mb-0 fw-bold text-primary">
            Administração Central
          </Navbar.Brand>
        </div>

        <Navbar.Toggle />
        <Navbar.Collapse>
          <Nav className="ms-auto align-items-center">
            {/* Botão para voltar ao Hub */}
            <Nav.Link as={Link} to="/hub" className="me-3">
              <FaHome className="me-1" />
              Voltar ao Hub
            </Nav.Link>

            {/* Dropdown do usuário */}
            <NavDropdown
              title={
                <span className="d-flex align-items-center">
                  <FaUserCircle className="me-2" />
                  {formatUserName()}
                </span>
              }
              id="user-dropdown"
              align="end"
            >
              <div className="dropdown-header">
                <div className="fw-bold">{userProfile?.full_name || 'Nome não informado'}</div>
                <small className="text-muted">{user?.email}</small>
              </div>
              
              <NavDropdown.Divider />
              
              <NavDropdown.Item 
                onClick={() => setShowLogoutModal(true)}
                className="text-danger"
                disabled={loggingOut}
              >
                <FaSignOutAlt className="me-2" />
                Sair
              </NavDropdown.Item>
            </NavDropdown>
          </Nav>
        </Navbar.Collapse>
      </Navbar>

      {/* Modal de confirmação de logout */}
      <Modal 
        show={showLogoutModal} 
        onHide={() => setShowLogoutModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirmar Logout</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {error && (
            <Alert variant="danger" className="mb-3">
              {error}
            </Alert>
          )}
          
          <p>Tem certeza que deseja sair do sistema?</p>
        </Modal.Body>
        <Modal.Footer>
          <Button 
            variant="secondary" 
            onClick={() => setShowLogoutModal(false)}
            disabled={loggingOut}
          >
            Cancelar
          </Button>
          <Button 
            variant="danger" 
            onClick={handleLogout}
            disabled={loggingOut}
          >
            <FaSignOutAlt className="me-2" />
            {loggingOut ? 'Saindo...' : 'Sair'}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Header;